export class Academics {
  difficultyClassIds: number[] = [];
  ebrw = null;
  math = null;
  actComp = null;
  sixYearGradRate = null;
  freshmenRetensionRate = null;
  standardizeTestScore = null;
  workStudyAvailable = null;
  satNotReported = null;
  actNotReported = null;
}
